import React from 'react'
import PropTypes from 'prop-types'
import Card from '../card/card'
import './card-grid.scss'

export default class CardGrid extends React.Component {
  render() {
    const { data, tag } = this.props;
    let withoutHidden = data.filter((item) => item.slug !== "/review/hidden-reivew/")
    withoutHidden = withoutHidden.filter((item) => item.slug !== "/blog/hidden-post/")

    return (
      <div className="card-grid">
        <div className="card-grid__wrapper">
          <h2 className="card-grid__title" id="reviews">{tag}</h2>
          <div className="card-grid__content">
            {withoutHidden.map((item, i) => (
              <div className="card-grid__card" key={item.id + i}>
                <Card
                  key={item.id}
                  url={item.slug}
                  title={item.title}
                  excerpt={item.excerpt}
                  created={item.created}
                  author={item.author}
                  image={item.image}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

CardGrid.propTypes = {
  data: PropTypes.array,
  tag: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/card-grid/card-grid.js